'use strict';

(function ($) {

  //Desabilita comportamento menu principal do Jornal do Carro
  $('.jc-nav-wrapper').css('position', 'static');
  $('.jc-nav-top-bar').remove();

  //slider
  $('.jc-inline-list-slide').slick({
    dots: true,
    lazyLoad: 'ondemand',
    infinite: true,
    slidesToShow: 7,
    slidesToScroll: 7,
    responsive: [{
      breakpoint: 1020,
      settings: {
        slidesToShow: 5,
        slidesToScroll: 5
      }
    }, {
      breakpoint: 768,
      settings: {
        slidesToShow: 5,
        slidesToScroll: 5
      }
    }, {
      breakpoint: 576,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        arrows: false,
        dots: true
      }
    }, {
      breakpoint: 450,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        arrows: false,
        dots: true
      }
    }]
  });
})(jQuery);